import React from "react";
import PropTypes from "prop-types";
import { Link } from "../Link";
import { useTheme } from "../theme";
import { HorizontalCard } from "../HorizontalCard";
import { Date } from "../Date";

// TODO: Use translation string for "by"
export function AuthoringInfo({
    className = "",
    authorName,
    authorLink,
    publishedDate,
    authorAvatar = null,
}) {
    const { altTextColor: authorNameColor } = useTheme();
    const avatarMaxWidth = 3.2;

    return (
        <HorizontalCard
            className={className}
            image={authorAvatar && <div className="avatar">{authorAvatar}</div>}
        >
            <p className="name">
                by{" "}
                <Link className="name__link" to={authorLink}>
                    {authorName}
                </Link>
                <AuthoringDate date={publishedDate} />
            </p>
            <style jsx>{`
                .avatar {
                    max-width: ${avatarMaxWidth}em;
                    max-height: ${avatarMaxWidth}em;
                    border-radius: ${avatarMaxWidth / 2}em;
                    overflow: hidden;
                }
                .name :global(.name__link) {
                    font-weight: 600;
                    color: ${authorNameColor};
                }
            `}</style>
        </HorizontalCard>
    );
}

AuthoringInfo.propTypes = {
    className: PropTypes.string,
    authorName: PropTypes.string,
    authorAvatar: PropTypes.element,
    authorLink: PropTypes.string,
    publishedDate: PropTypes.string.isRequired,
};

AuthoringInfo.defaultProps = {
    className: "",
    authorName: "",
    authorLink: "",
    authorAvatar: null,
};

export function AuthoringDate({ className = "", date }) {
    const { secondaryTextColor, modularScale } = useTheme();
    return (
        <span className={`authoring-date ${className}`}>
            <span className="date override-global-styles">
                <Date isoDateString={date} />
            </span>
            <style jsx>{`
                .authoring-date {
                    display: block;
                }
                .date.override-global-styles {
                    font-size: ${modularScale(-1)}em;
                    line-height: 1.2;
                    color: ${secondaryTextColor};
                }
            `}</style>
        </span>
    );
}

AuthoringDate.propTypes = {
    className: PropTypes.string,
    date: PropTypes.string.isRequired,
};

AuthoringDate.defaultProps = {
    className: "",
};
